import styled from 'styled-components';

const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export default Fields;
